// Lịch tự động (customers/details/weekly/revenues/quotesAll/supportRevenue) đã CHUYỂN sang
// chạy NỀN NGAY TRÊN SERVER (backend/src/cron.js), dùng token SocSon đã lưu — không cần máy
// nào mở app + tab SocSon + extension nữa. Giữ component rỗng để không phải sửa App.jsx.
export default function AutoSync() {
  return null;
}
